import createSimpleComponent from '../createSimpleComponent'

import cls from './content-title.module.scss'

export const ContentTitleHighlight = createSimpleComponent({
  displayName: 'ContentTitleHighlight',
  className: cls.ContentTitleHighlight,
  Component: 'span',
})
